import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Clock, AlertCircle, Pause } from 'lucide-react';
import { format } from 'date-fns';
import { api } from '../api/client';
import { Badge } from '../components/ui/Badge';
import { ETAPA_MAP } from '../lib/constants';
import { parseDate } from '../lib/dates';

const STATUS_ICON = {
  pendente: Clock,
  em_andamento: AlertCircle,
  bloqueada: Pause,
};

export function MinhaFilaPage() {
  const nav = useNavigate();
  const [tarefas, setTarefas] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get('/demandas/_tarefas/minhas').then((r) => setTarefas(r.tarefas)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const mudar = async (t, status) => {
    await api.patch(`/demandas/${t.demanda_codigo}/tarefas/${t.id}`, { status });
    load();
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Minha fila</h1>
          <p className="page-subtitle">{tarefas.length} tarefa{tarefas.length === 1 ? '' : 's'} atribuídas a você</p>
        </div>
      </div>
      {loading ? <div className="loader-full"><span className="spinner" /></div> :
        tarefas.length === 0 ? (
          <div className="card"><div className="card-body center" style={{ padding: 40 }}>
            <div className="muted">Nada pendente. 🎉</div>
          </div></div>
        ) : (
          <div className="stack" style={{ gap: 10 }}>
            {tarefas.map((t) => {
              const Icon = STATUS_ICON[t.status] || Clock;
              return (
                <div key={t.id} className="card">
                  <div className="card-body" style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: 14 }}>
                    <button onClick={() => mudar(t, 'concluida')} style={{ marginTop: 2, border: 'none', background: 'transparent', cursor: 'pointer' }}>
                      <div style={{ width: 20, height: 20, borderRadius: 10, border: '2px solid var(--c-border-strong)' }} />
                    </button>
                    <div style={{ flex: 1, minWidth: 0, cursor: 'pointer' }} onClick={() => nav(`/demandas/${t.demanda_codigo}`)}>
                      <div style={{ fontWeight: 600, fontSize: 15 }}>{t.titulo}</div>
                      <div className="text-xs muted" style={{ marginTop: 2 }}>{t.demanda_titulo} · {t.secretaria_nome}</div>
                      <div className="row-wrap" style={{ gap: 6, marginTop: 6 }}>
                        <Badge color={t.status === 'em_andamento' ? 'info' : t.status === 'bloqueada' ? 'danger' : 'default'}>
                          <Icon size={11} /> {t.status === 'em_andamento' ? 'Em andamento' : t.status === 'bloqueada' ? 'Bloqueada' : 'Pendente'}
                        </Badge>
                        <Badge color={ETAPA_MAP[t.demanda_etapa]?.color}>{ETAPA_MAP[t.demanda_etapa]?.label}</Badge>
                        {t.prioridade === 'urgente' && <Badge color="danger">URGENTE</Badge>}
                        {t.prioridade === 'alta' && <Badge color="warning">Alta</Badge>}
                        {t.prazo && <span style={{ fontSize: 11, color: 'var(--c-warning)' }}>⏰ {format(parseDate(t.prazo), 'dd/MM')}</span>}
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      {t.status !== 'em_andamento' && (
                        <button className="btn btn-secondary btn-sm" onClick={() => mudar(t, 'em_andamento')}>Começar</button>
                      )}
                      {t.status !== 'bloqueada' && (
                        <button className="btn btn-ghost btn-sm" onClick={() => mudar(t, 'bloqueada')} title="Marcar como bloqueada">
                          <Pause size={12} />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}
